import { Box, Typography, styled } from "@mui/material";
import { useEffect, useState } from "react";

import { DefaultUrlWeb } from "config/Configuration";
import Modal from "components/Modal";
import NumberFormats from "components/NumberFormats";
import { TRADE_SIDE } from "../constants";
import TimeoutButton from "components/TimeoutButton";
import { useFormContext } from "react-hook-form";

function TradeInitialConfirmModal({
  open,
  onClose,
  tradeInsertInitial,
  handleConfirmTradeInitial,
  loading
}) {
  const { reset } = useFormContext();

  const [startTimer, setStartTimer] = useState(false);

  useEffect(() => {
    if (open) {
      setStartTimer(true);
    } else {
      setStartTimer(false);
    }
  }, [open]);

  const handleTimeoutComplete = () => {
    reset((formValues) => ({
      ...formValues,
      price: "",
      amount: "",
    }));

    onClose();
  };

  return (
    <Modal
      maxWidth="xs"
      onClose={onClose}
      open={open}
      title="Confirm"
      dir="ltr"
    >
      <BoxCoin>
        <img
          src={DefaultUrlWeb + tradeInsertInitial?.coinSourceImageUrl}
          alt={tradeInsertInitial?.coinSourceName}
        />

        <Typography fontWeight={600}>
          {tradeInsertInitial?.coinSourceName}
        </Typography>

        <Typography color="text.secondary">
          {" "}
          / {tradeInsertInitial?.coinDestinationName}
        </Typography>
      </BoxCoin>

      <Typography
        color={
          tradeInsertInitial?.sideId === TRADE_SIDE.Sell.id
            ? "error.main"
            : "success.main"
        }
        padding={(2, 2.4)}
      >
        {tradeInsertInitial?.side} {tradeInsertInitial?.walletType}{" "}
        / {tradeInsertInitial?.type}
      </Typography>

      <BoxStyle>
        <Typography>Amount</Typography>

        <Typography>
          <Typography variant="span" color="text.main">
            <NumberFormats value={tradeInsertInitial?.filled} />
          </Typography>{" "}
          <Typography variant="span">
            {" "}
            {tradeInsertInitial?.coinSourceName}
          </Typography>
        </Typography>
      </BoxStyle>

      <BoxStyle>
        <Typography>Price</Typography>

        <Typography>
          <Typography variant="span" color="text.main">
            <NumberFormats value={tradeInsertInitial?.price} />
          </Typography>{" "}
          <Typography variant="span">
            {" "}
            {tradeInsertInitial?.coinDestinationName}
          </Typography>
        </Typography>
      </BoxStyle>

      <BoxStyle>
        <Typography>Total</Typography>

        <Typography>
          <Typography variant="span" color="text.main">
            <NumberFormats value={tradeInsertInitial?.total} />
          </Typography>
          <Typography variant="span">
            {" "}
            {tradeInsertInitial?.coinDestinationName}
          </Typography>
        </Typography>
      </BoxStyle>

      <TimeoutButton
        start={startTimer}
        time={tradeInsertInitial?.validSeconds}
        onClick={() => handleConfirmTradeInitial(tradeInsertInitial)}
        onComplete={handleTimeoutComplete}
        title="Confirm"
        color="success"
        loading={loading}
        fullWidth
      />
    </Modal>
  );
}
const BoxCoin = styled(Box)(({ theme }) => ({
  color: theme.palette.text.main,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  img: {
    width: "25px",
    height: "25px",
    marginRight: "15px",
  },
}));

const BoxStyle = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  fontWeight: "400",
  fontSize: "14px",
  lineHeight: "16px",
  marginBottom: theme.spacing(2),
  paddingLeft: theme.spacing(2.4),
  paddingRight: theme.spacing(2.4),
  color: theme.palette.text.secondary,
}));
export default TradeInitialConfirmModal;
